import {required, requiredIf} from 'vuelidate/lib/validators'

const requiredIfSpecial = requiredIf((vm) => {
  return vm.gyneDiagnosis === 3
});

const requiredIfOtherComplication = requiredIf((vm) => {
  return vm.gtdComplication === 8
});

const requiredIfSurgical = requiredIf((vm) => {
  return vm.medicalSurgical === 2
});

const requiredIfOtherIntervention = requiredIf((vm) => {
  return vm.surgicalIntervention === 6
});

const requiredIfGyneDiagnosisIsEmpty = requiredIf((vm) => {
  if (!vm.gynecologicalDiagnosis || (Array.isArray(vm.gynecologicalDiagnosis) && vm.gynecologicalDiagnosis.length === 0)) {
    return true;
  } else {
    return false;
  }
});

export default {
  gynecologicalDiagnosis: {
    required
  },
  // },
  // gyneOrgan: {
  //   required
  // },
  // organCondition: {
  //   required
  // },
  // gyneDiagnosis: {
  //   required
  // },
  // medicalSurgical: {
  //   required
  // },
  // gtdDiagnosis: {
  //   requiredIf: requiredIfSpecial
  // },
  // gtdComplication: {
  //   requiredIf: requiredIfSpecial
  // },
  // gtdComplicationOthers: {
  //   requiredIf: requiredIfOtherComplication
  // },
  // surgicalIntervention: {
  //   requiredIf: requiredIfSurgical
  // },
  // surgicalInterventionOthers: {
  //   requiredIf: requiredIfOtherIntervention
  // }
}
